import styled from 'styled-components';
import { StyledActionSheetContainer } from '../../../../components/modal/modal.style';

export const StyledHoursWorkedHourlyDetailsActionSheetContainer = styled(StyledActionSheetContainer)`
  padding: 24px;
  padding-top: 0;
  overflow-y: auto;
`;
